import { memo } from 'react';
import NextLink from 'next/link';
import NextImage from 'next/image';

import { ABA_ROUTE, HOME_ROUTE } from 'constants/routes';
import { Container } from '../common/container';
import Text from '../common/text';
import { FooterTopWrapper } from './styles';
import {
  BLOG_LINK,
  FAQ_LINK,
  HOME_PAGE_LINK,
  MANIFESTO_LINK,
  PRIVACY_LINK,
  TERMS_AND_PRIVACY_LINK,
} from 'constants/links';

type FooterTopProps = {
  forIframe?: boolean;
};

function FooterTop({ forIframe }: FooterTopProps) {
  return (
    <FooterTopWrapper>
      <Container size="md">
        <div className="footer-logo">
          <NextLink href={forIframe ? HOME_PAGE_LINK : HOME_ROUTE} passHref>
            <a>
              <NextImage
                src="/static/logo-richr-new-colored.svg"
                width={132}
                height={44}
                priority
                quality={100}
              />
            </a>
          </NextLink>
        </div>
        <div className="footer-nav">
          <div className="footer-nav-col">
            <Text>About</Text>
            <div>
              <NextLink href={MANIFESTO_LINK} passHref>
                <a target="_blank">
                  <Text>Manifesto</Text>
                </a>
              </NextLink>
            </div>
          </div>
          <div className="footer-nav-col">
            <Text>Terms & Privacy</Text>
            <div>
              <NextLink href={TERMS_AND_PRIVACY_LINK} passHref>
                <a target="_blank">
                  <Text>Terms of Service</Text>
                </a>
              </NextLink>
              <NextLink href={PRIVACY_LINK} passHref>
                <a target="_blank">
                  <Text>Privacy Policy</Text>
                </a>
              </NextLink>
              <NextLink href={ABA_ROUTE} passHref>
                <a target="_blank">
                  <Text>Affiliated Business Disclosure</Text>
                </a>
              </NextLink>
            </div>
          </div>
          <div className="footer-nav-col">
            <Text>Resources</Text>
            <div>
              <NextLink href={BLOG_LINK} passHref>
                <a target="_blank">
                  <Text>Blog</Text>
                </a>
              </NextLink>
              <NextLink href={FAQ_LINK} passHref>
                <a target="_blank">
                  <Text>FAQ</Text>
                </a>
              </NextLink>
            </div>
          </div>
          <div className="footer-nav-col">
            <Text>Resources</Text>
            <div>
              <NextLink href="https://twitter.com/getrichrnow/" passHref>
                <a target="_blank">
                  <Text>Twitter</Text>
                </a>
              </NextLink>
              <NextLink
                href="https://www.pinterest.com.au/getrichrnow/"
                passHref
              >
                <a target="_blank">
                  <Text>Pinterest</Text>
                </a>
              </NextLink>
              <NextLink href="https://www.instagram.com/getrichrnow/" passHref>
                <a target="_blank">
                  <Text>Instagram</Text>
                </a>
              </NextLink>
              <NextLink href="https://www.facebook.com/getrichrnow" passHref>
                <a target="_blank">
                  <Text>Facebook</Text>
                </a>
              </NextLink>
            </div>
          </div>
        </div>
        <div className="footer-alt">
          <Text>
            © Copyright {new Date().getFullYear()}. Richr Inc. ALL RIGHTS
            RESERVED.
          </Text>
        </div>
      </Container>
    </FooterTopWrapper>
  );
}

export default memo(FooterTop);
